import { ChangeDetectorRef, Component, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/operators';
//import { desAdminDecisionService } from './service/des-admin-decision.service'
import { HEC_CONSTANTS } from '../../../../utilities/constants';
import { HecResponse } from '../../../shared-interfaces/hecResponse';
import { CommonHelper } from '../../../../utilities/common.helper';
import moment from 'moment';

@Component({
  selector: 'kt-export-file',
  templateUrl: './export-file.component.html',
  styleUrls: ['./export-file.component.css']
})
export class ExportFileComponent implements OnInit {
  @ViewChild('exportFileForm', { static: false }) exportFileForm: NgForm;
  public roleList: any[] = []
  private _onDestroy = new Subject<void>();
  public applicationType: string = ''
  loader: boolean;
  showUserlist: boolean = false;
  dropdownList: any = [];
  minEndDate: any;
  isFinalLetter = false
  public minDate = moment("2021-1-1").format('YYYY-MM-DD');
  public statusDropdown = [
    {label: "Provisional Letter Issued", value: 1},
    {label: "Final Letter Issued", value: 0},
    {label: "All", value: 2}
  ]
  constructor(private dialogRef: MatDialogRef<ExportFileComponent>, @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
  private cdr:ChangeDetectorRef,
  //public DesAdminDecisionService: desAdminDecisionService,
    private route: ActivatedRoute,private router:Router) { }

  ngOnInit() {
    this.isFinalLetter = this.data.isFinalLetter
    console.log(this.data, this.isFinalLetter)


  }

  public decline() {
    this.dialogRef.close(false);
  }

  public accept(value) {
    this.dialogRef.close(value);
  }

  public dismiss(type) {
    this.dialogRef.close(false);
  }

  submit(): void {
    this.markFormsTouched(this.exportFileForm);
		if (this.validate(this.exportFileForm)) {
    this.accept(this.exportFileForm.value)
    }
    else return
  }



  
  public getEndDate(date){
    this.exportFileForm.form.controls.endDate.reset();
		this.minEndDate = date
	  }



private markFormsTouched(form): void {
  CommonHelper.markFormGroupTouched(form);
}


public validate(f): boolean {
  if (f.status === "VALID") {
    return true;
  }
}
public Reset() {

  this.exportFileForm.reset();

}
}

